import { Modal, Spin, Tooltip } from "antd";
import { toJpeg } from "html-to-image";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Facebook from "../../../Assets/Images/facebook.png";
import Instagram from "../../../Assets/Images/Instagram.png";
import Linkedin from "../../../Assets/Images/linkedin.png";
import logo from "../../../Assets/Images/logo.png";
import medalImg from "../../../Assets/Images/madal.png";
import Twitter from "../../../Assets/Images/Twitter.png";
import { onFileUpload } from "../../Helper/MediaUploader";
import { CustIcon } from "../../Svgs";
import { useQRCode } from "next-qrcode";
import "./SealShareModal.less";
import { Loader } from "../../Loader/Loader";

const { REACT_APP_ASSETS_URL } = process.env;

export const SealShareModal = ({
  onHideModal,
  userData,
  bussiness_name,
  count,
}) => {
  const ref = useRef(null);
  const printRef = useRef();
  const [isUploading, setIsUploading] = useState(false);
  const [qrUrl, setQrUrl] = useState("");
  const { Canvas } = useQRCode();

  useEffect(() => {
    if (!!qrUrl) {
      downloadImage(printRef, `${new Date().getTime()}-${count}-seal-qr.jpg`);
    }
  }, [count, qrUrl]);

  const handleCancel = () => {
    onHideModal();
  };

  /**
   * downloadImage
   * @description get current referrence div and convert html to png image.
   */

  const downloadImage = (ref, fileName) => {
    if (ref.current === null) {
      return;
    }
    toJpeg(ref.current, { cacheBust: true })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = fileName;
        link.href = dataUrl;
        link.click();
        setIsUploading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onQrDownload = useCallback(async () => {
    setIsUploading(true);
    if (ref.current === null) {
      return;
    }
    const dataURLtoFile = (dataurl, filename) => {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    };

    toJpeg(ref.current, { cacheBust: true })
      .then((dataUrl) => {
        let fileName = `${localStorage.getItem(
          "user_id"
        )}-${new Date().getTime()}-${count}.jpg`;
        const yourFile = dataURLtoFile(dataUrl, fileName);
        const file = {
          action: "",
          filename: "file",
          data: {},
          file: yourFile,
          headers: {},
          withCredentials: false,
          method: "post",
        };
        onFileUpload(file, "medals", onMedalUploadSuccess, setIsUploading);
      })
      .catch((err) => {
        console.log(err);
      });

    const onMedalUploadSuccess = async (fileUrl) => {
      setQrUrl(REACT_APP_ASSETS_URL + fileUrl);
    };
  }, [ref, count]);

  return (
    <>
      <Modal
        visible={true}
        onCancel={handleCancel}
        closable={true}
        footer={null}
        className="sharemodal"
        width={838}
      >
        <div className="sharemodal-main">
          <div className="sharemodal-main-header">
            <div className="location">
              <h3>
                {bussiness_name
                  ? bussiness_name
                  : userData?.getUsersById?.user_location_maps.map(
                      (b) => b?.businessDetails?.business_name
                    )[0]}
              </h3>
              {/* <img src={logo}></img> */}
            </div>
            <div className="share-icons">
              {/* <div className="">
                <span className="loaderBtn">
                  <Spin />
                </span>
              </div> */}
              <Tooltip title="Download QR">
                <div>
                  <span
                    onClick={onQrDownload}
                    className="fb-xfbml-parse-ignore"
                  >
                    <CustIcon type="qr_code" />
                  </span>
                </div>
              </Tooltip>
              <Tooltip title="Share">
                <div>
                  <a
                    target={`_blank`}
                    href={`https://www.facebook.com`}
                    className="fb-xfbml-parse-ignore"
                  >
                    <img src={Facebook} alt="" />
                  </a>
                </div>
              </Tooltip>
              <Tooltip title="Share">
                <div>
                  <a
                    target={`_blank`}
                    href={`https://twitter.com/i/flow/login`}
                    className="fb-xfbml-parse-ignore"
                  >
                    <img src={Twitter} alt="" />
                  </a>
                </div>
              </Tooltip>
              <Tooltip title="Share">
                <div>
                  <a
                    target={`_blank`}
                    href={`https://www.instagram.com`}
                    className="fb-xfbml-parse-ignore"
                  >
                    <img src={Instagram} alt="" />
                  </a>
                </div>
              </Tooltip>
              <Tooltip title="Share">
                <div>
                  <a
                    target={`_blank`}
                    href={`https://www.linkedin.com/login`}
                    className="fb-xfbml-parse-ignore"
                  >
                    <img src={Linkedin} alt="" />
                  </a>
                </div>
              </Tooltip>
              <Tooltip title="Download image">
                <div
                  onClick={() => {
                    downloadImage(ref, "seal-share.jpg");
                  }}
                  className="downloadImgBtn"
                >
                  <CustIcon type="download" />
                </div>
              </Tooltip>
            </div>
          </div>
          <div className="sharemodal-content">
            <div className="sharemodal-image">
              <img src={medalImg} alt="medal" />
            </div>
            <div className="rating-count">
              <p>
                Our <strong>completion rate</strong> for Sanitization and
                Cleaning activities is
              </p>
              <div className="green counter">{count}%</div>
            </div>

            <div className="logoPop">
              <img src={logo} />
            </div>
          </div>
          <div className="footer">
            <div className="sharemodal-footer">
              <span>
                This seal symbolizes the real-time evidence of policy
                understanding and compliance with corporate and government
                mandated directives regarding sanitization and cleanliness.
                Please visit www.sanattest.com for any queries.
              </span>
            </div>
          </div>
          {isUploading && (
            <dic className="loadersection">
              <Loader />
            </dic>
          )}
        </div>

        <div className="downloadImg">
          <div className="downloadModal-main" ref={ref}>
            <div className="downloadModal-main-header">
              <div className="location">
                <h3>
                  {bussiness_name
                    ? bussiness_name
                    : userData?.getUsersById?.user_location_maps.map(
                        (b) => b?.businessDetails?.business_name
                      )[0]}
                </h3>
              </div>
              <div className="share-icons">
                <div className="ml-3">
                  <img src={Facebook} alt="" />
                </div>
                <div className="ml-3">
                  <img src={Twitter} alt="" />
                </div>
                <div className="ml-3">
                  <img src={Instagram} alt="" />
                </div>
                <div className="ml-3">
                  <img src={Linkedin} alt="" />
                </div>
              </div>
            </div>
            <div className="downloadModal-content">
              <div className="downloadModal-image">
                <img src={medalImg} alt="medal" />
              </div>
              <div className="rating-count">
                <p>
                  Our <strong>completion rate</strong> for Sanitization and
                  Cleaning activities is
                </p>
                <div className="green counter">{count}%</div>
              </div>

              <div className="logoPop">
                <img src={logo} alt="logo" />
              </div>
            </div>
            <div className="footer">
              <div className="downloadModal-footer">
                <span>
                  This seal symbolizes the real-time evidence of policy
                  understanding and compliance with corporate and government
                  mandated directives regarding sanitization and cleanliness.
                  Please visit www.sanattest.com for any queries.
                </span>
              </div>
            </div>
          </div>

          {qrUrl && (
            <div className="downloadModal-main" ref={printRef}>
              <div className="downloadModal-main-header">
                <div className="location">
                  <h3>
                    {bussiness_name
                      ? bussiness_name
                      : userData?.getUsersById?.user_location_maps.map(
                          (b) => b?.businessDetails?.business_name
                        )[0]}
                  </h3>
                </div>
                <div className="share-icons">
                </div>
              </div>
              <div className="downloadModal-content pb-3">
                <div className="downloadModal-image">
                  <img src={medalImg} alt="medal" />
                </div>
                <div className="rating-count pt-0">
                  <h4 className="text-secondary">Check our cleanliness standards!</h4>
                  <p className="">
                    This QR when scanned will show you the cleanliness standards
                    maintained at our premises. Please scan for further
                    information.
                  </p>
                  <div className="qrCodeSection mb-0">
                    <Canvas
                      text={qrUrl}
                      options={{
                        type: "image/jpeg",
                        quality: 1,
                        level: "H",
                        margin: 0,
                        scale: 1,
                        width: 160,
                        color: {
                          light: "#ffffff",
                        },
                      }}
                    />
                  </div>
                </div>

                <div className="logoPop">
                  <img src={logo} alt="logo" />
                </div>
              </div>
              <div className="footer">
                <div className="downloadModal-footer">
                  <span>
                    This seal symbolizes the real-time evidence of policy
                    understanding and compliance with corporate and government
                    mandated directives regarding sanitization and cleanliness.
                    Please visit www.sanattest.com for any queries.
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};
